import React from 'react'
import PostPage from "../components/Post"
export default function Post() {
  return <PostPage/>
}

